export default __webpack_public_path__ + "static/char-s-16-chs-3c31bfe22777adb91e762b6d54490531.webp";